module.exports = __webpack_public_path__ + "img/standard-documents.79245d88.svg";